function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_27647_29732)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.0116 2.73773H18.6111C9.87281 2.73773 2.78906 9.82148 2.78906 18.5597V46.9602C2.78906 55.6985 9.87281 62.7822 18.6111 62.7822H47.0116C55.7498 62.7822 62.8336 55.6985 62.8336 46.9602V18.5597C62.8336 9.82148 55.7498 2.73773 47.0116 2.73773Z",
  stroke: "white",
  strokeWidth: 3,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.3362 41.6599C30.9122 41.6599 29.8047 42.8069 29.8047 44.1914C29.8047 45.6549 30.9518 46.7624 32.3362 46.7624C33.7206 46.7624 34.8677 45.6154 34.8677 44.2309C34.8677 42.7674 33.7206 41.6599 32.3362 41.6599Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.6135 18.718C29.6864 18.718 26.7594 20.1419 25.4936 22.9899C24.8607 24.4534 26.0078 26.1147 27.59 26.1147C28.4602 26.1147 29.2513 25.6005 29.6469 24.8094C30.1611 23.6623 31.3873 23.069 32.574 23.069C34.1957 23.069 35.5801 24.1765 35.5801 25.9961C35.5801 27.6574 34.5122 28.4485 33.286 29.3187C31.7038 30.4262 29.9238 31.7316 29.9238 35.1728V35.4893C29.9238 36.8341 30.9918 37.9021 32.3366 37.9021C33.6815 37.9021 34.7495 36.8341 34.7495 35.4893V35.1728C34.7495 33.4324 35.857 32.5622 37.1228 31.6129C38.6259 30.4262 40.2872 29.1605 40.2872 25.9961C40.2872 21.3286 36.569 18.718 32.6135 18.718Z",
  fill: "white"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_27647_29732"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  fill: "white",
  transform: "translate(0.8125 0.76001)"
})));
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.f69b131567b8fb904731e9db4126cd80.svg";
export { ForwardRef as ReactComponent };